import { List } from 'immutable';
export const getEventDisplayState = eventDisplay => {
  let showAllDayEvents = false;
  let showEvents = false;
  for (const eventType of eventDisplay) {
    switch (eventType) {
      case 'all-day-events':
        showAllDayEvents = 'expanded';
        break;
      case 'all-day-events-collapsed':
        showAllDayEvents = 'collapsed';
        break;
      case 'events':
        showEvents = true;
        break;
      default:
        break;
    }
  }
  return {
    showAllDayEvents,
    showEvents
  };
};
/**
 * Iterates over the events and figures out what events to show and separates
 * out all day events from regular events. It also filters out events that are
 * outside of the time window passed. Assumes events have already been sorted
 * chronologically. It will stop iterating over events once it reaches the end
 * of the time window.
 */
export const getEventsToDisplay = ({
  sortedChildren,
  eventDisplay,
  eventRange
}) => {
  const {
    showAllDayEvents,
    showEvents
  } = getEventDisplayState(eventDisplay);
  const result = {
    allEvents: [],
    allDayEvents: [],
    events: []
  };
  for (const child of sortedChildren) {
    const {
      start,
      end,
      allDay
    } = child.props;
    if (eventRange) {
      if (end < eventRange.start) {
        continue;
      }
      if (start > eventRange.end) {
        break;
      }
    }
    if (showAllDayEvents && allDay) {
      result.allDayEvents.push(child);
      result.allEvents.push(child);
    } else if (showEvents && !allDay) {
      result.allEvents.push(child);
      result.events.push(child);
    }
  }
  return {
    allEvents: List(result.allEvents),
    allDayEvents: List(result.allDayEvents),
    events: List(result.events)
  };
};
export const toggleAllDayEvents = current => {
  switch (current) {
    case 'expanded':
      return 'collapsed';
    case 'collapsed':
      return 'expanded';
    case false:
    default:
      return false;
  }
};